/*
  Shared accessible modal controller for the 4 Flowra content popups
  (doctors, Size Guide, How It Works, Fabric & Care). Mirrors the
  focus-trap/Esc/backdrop-click/scroll-lock/focus-return behavior
  already validated in the local mockup's openOverlay()/closeOverlay().

  Triggers: any element with [data-flowra-modal-open="MODAL_ID"].
  Close buttons inside a modal: [data-flowra-modal-close].
*/
(function () {
  var scrollLockCount = 0;
  function lockScroll() {
    scrollLockCount++;
    document.body.style.overflow = 'hidden';
  }
  function unlockScroll() {
    scrollLockCount = Math.max(0, scrollLockCount - 1);
    if (scrollLockCount === 0) document.body.style.overflow = '';
  }

  function trapFocus(container, event) {
    var focusable = container.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function openFlowraModal(id, triggerEl) {
    var modal = document.getElementById(id);
    if (!modal || modal.classList.contains('is-open')) return;
    /*
      Dawn's scroll-reveal animation (settings.animations_reveal_on_scroll)
      applies a `transform` to .product__info-wrapper (the buybox
      column these modals render inside) -- any non-"none" transform
      on an ancestor creates a NEW CONTAINING BLOCK for position:fixed
      descendants per the CSS spec, so the modal overlay was being
      sized/positioned relative to that narrow column instead of the
      real viewport (this is what read as "abrindo uma tela grande" /
      wrong proportions -- the modal panel itself was styled
      correctly, it just couldn't see the real viewport). Portal the
      overlay to be a direct child of <body> while open, exactly like
      most modal libraries do, which is immune to any ancestor's
      transform/filter/contain (Fase 9 R4 fix).
    */
    if (modal.parentElement !== document.body) {
      modal._originalParent = modal.parentElement;
      modal._originalNextSibling = modal.nextSibling;
      document.body.appendChild(modal);
    }
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    lockScroll();
    modal._returnFocusEl = triggerEl || document.activeElement;
    var closeBtn = modal.querySelector('[data-flowra-modal-close]');
    setTimeout(function () {
      if (closeBtn) closeBtn.focus();
    }, 30);
    modal._keydownHandler = function (e) {
      if (e.key === 'Escape') {
        e.stopPropagation();
        closeFlowraModal(id);
      } else if (e.key === 'Tab') {
        trapFocus(modal, e);
      }
    };
    document.addEventListener('keydown', modal._keydownHandler);
    modal._backdropHandler = function (e) {
      if (e.target === modal) closeFlowraModal(id);
    };
    modal.addEventListener('mousedown', modal._backdropHandler);
  }

  function closeFlowraModal(id) {
    var modal = document.getElementById(id);
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    unlockScroll();
    if (modal._keydownHandler) {
      document.removeEventListener('keydown', modal._keydownHandler);
      modal._keydownHandler = null;
    }
    if (modal._backdropHandler) {
      modal.removeEventListener('mousedown', modal._backdropHandler);
      modal._backdropHandler = null;
    }
    if (modal._returnFocusEl && typeof modal._returnFocusEl.focus === 'function') {
      modal._returnFocusEl.focus();
    }
    if (modal._originalParent) {
      if (modal._originalNextSibling) {
        modal._originalParent.insertBefore(modal, modal._originalNextSibling);
      } else {
        modal._originalParent.appendChild(modal);
      }
      modal._originalParent = null;
      modal._originalNextSibling = null;
    }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-flowra-modal-open]');
    if (opener) {
      e.preventDefault();
      openFlowraModal(opener.getAttribute('data-flowra-modal-open'), opener);
      return;
    }
    var closer = e.target.closest('[data-flowra-modal-close]');
    if (closer) {
      var modal = closer.closest('.flowra-modal-overlay');
      if (modal) closeFlowraModal(modal.id);
    }
  });

  window.FlowraModals = { open: openFlowraModal, close: closeFlowraModal };
})();
